import apiClient from '@u/apiClient'
import Promise from 'lodash-es/_Promise'
import GetWikiCityListController from '@/wayfinder/actions/App/Http/Controllers/WikiCity/GetWikiCityListController'
import GetClosestWikiCityListController from '@/wayfinder/actions/App/Http/Controllers/WikiCity/GetClosestWikiCityListController'
import GetFavoriteWikiCityListController from '@/wayfinder/actions/App/Http/Controllers/WikiCity/GetFavoriteWikiCityListController'
import GetWikiCityByIdController from '@/wayfinder/actions/App/Http/Controllers/WikiCity/GetWikiCityByIdController'
import GetNewModelController from '@/wayfinder/actions/App/Http/Controllers/NewModel/GetNewModelController'
import CreateWikiCityController from '@/wayfinder/actions/App/Http/Controllers/WikiCity/CreateWikiCityController'
import UpdateWikiCityController from '@/wayfinder/actions/App/Http/Controllers/WikiCity/UpdateWikiCityController'
import ChangeFavoriteStatusWikiCityController from '@/wayfinder/actions/App/Http/Controllers/WikiCity/ChangeFavoriteStatusWikiCityController'
import GetWikiCityActivitiesByIdController from '@/wayfinder/actions/App/Http/Controllers/WikiCity/GetWikiCityActivitiesByIdController'

let base_errors = { deceased: {}, events: [] }

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}

export default {
  async fetchAllCities({ commit }) {
    await apiClient
      .route(GetWikiCityListController.get())
      .then(async (response) => {
        if (response.status === 200) {
          commit('setCities', response.data.cities)
        }
      })
      .catch(async (reason) => {
        await console.error('', reason)
      })
  },

  fetchClosestCities({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetClosestWikiCityListController.get(), {
          params: payload.params
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  async fetchFavoriteCities({ commit }) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(GetFavoriteWikiCityListController.get())
      .then(async (response) => {
        if (response.status === 200) {
          commit('setFavoriteCities', response.data.cities)
        }
      })
      .catch(async (reason) => {
        await console.error('fetchFavoriteCities', reason)
      })
  },

  async fetchCityById({ commit, dispatch }, payload) {
    commit('auth/setErrors', base_errors, { root: true })

    return await apiClient
      .route(GetWikiCityByIdController.get({ city: payload.city_id }))
      .then(async (response) => {
        if (response.status === 200) {
          commit('setCity', response.data.wiki_city)

          return response.data.wiki_city
        }

        return null
      })
      .catch(async (reason) => {
        await console.error('fetchCityById', reason)
      })
  },

  async fetchNewCity({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })

    return await apiClient
      .route(GetNewModelController.get(), {
        params: {
          model: 'wikiCity',
          parent_id: payload?.parent_id
        }
      })
      .then(async (response) => {
        if (response.status === 200) {
          commit('setCity', response.data.wikiCity)

          return response.data.wikiCity
        }

        return null
      })
      .catch(async (reason) => {
        await console.error('fetchNewCity', reason)
      })
  },

  async storeCity({ commit }, payload) {
    await apiClient
      .route(CreateWikiCityController.post(), payload.city)
      .then(async (response) => {
        if (response.status === 200) {
          processSuccessCallback(payload)
          commit('setCities', response.data.cities)
        }
      })
      .catch(async (reason) => {
        await console.error('storeCity', reason)
      })
  },

  async updateCity({ commit }, payload) {
    await apiClient
      .route(
        UpdateWikiCityController.put({ city: payload.city_id }),
        payload.city
      )
      .then(async (response) => {
        await console.log('updateCity', response)
        if (response.status === 200) {
          commit('setCity', response.data.wiki_city)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        await console.error('updateCity', reason)
      })
  },

  changeFavoriteCity: ({ commit }, payload) => {
    commit('auth/setErrors', base_errors, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          ChangeFavoriteStatusWikiCityController.put({ city: payload.city_id }),
          {
            is_favorite: payload.is_favorite
          }
        )
        .then((response) => {
          resolve(response)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchCityById2({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetWikiCityByIdController.get({ city: payload.city_id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchWikiCityActivities({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetWikiCityActivitiesByIdController.get({ city: payload.city_id })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
